// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { FunctionComponent, PropsWithChildren, ReactElement } from "react";
import { useParams } from "react-router-dom";
import ListProjectDetail from "../../components/list-views/project/ListProjectDetail";
import DOMPurify from "dompurify";

type ProjectDetailsPropsInterface = {
}

type ProjectDetailsRouteParams = {
    projectId: string;
}

export const ProjectDetails: FunctionComponent<PropsWithChildren<ProjectDetailsPropsInterface>> = (
): ReactElement => {

    const { projectId: id } = useParams<ProjectDetailsRouteParams>();
    const projectId = id ? DOMPurify.sanitize(id) : "";

    return (
        <>
            <ListProjectDetail id={projectId} />
        </>
    );
}
